<template>
  <v-select
    :label="$t('AccountLogs.category')"
    v-model="model"
    :items="logTypes"
    item-text="value"
    item-value="key"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
  ></v-select>
</template>

<script>
import Logs from "@/api/logs";


export default {
  name: "SearcherLogTypes",

  props: ["value"],


  computed: {
    logTypes() {
      let arr = []
      for(let index in this.log_types){
          let i = {};
          i.key = index;
          i.value = this.log_types[index]
          arr.push(i)
      }
      return arr
    },
  },
  mounted(){
      this.getLogTypes()
  },
  methods:{
      getLogTypes(){
          Logs.fetchLogTypes().then(
              function (response){
                  if(response.data.status.isOK()){
                      this.log_types = response.data.log_types
                  }
              }.bind(this)
          )
      }
  },

  data: () => ({
    model: [],
    log_types:[]

  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      handler() {
        this.$emit("input", this.model);
      },
    },
  },
};
</script>
